enum TreatmentUnit {
  Units = 0,
  Cycles = 2,
  Ml = 1,
  Passes = 3,
  Syringe = 4,
}

const TREATMENT_UNITS_MAP: { [key in TreatmentUnit]: string } = {
  [TreatmentUnit.Units]: 'Units',
  [TreatmentUnit.Cycles]: 'Cycles',
  [TreatmentUnit.Ml]: 'ml',
  [TreatmentUnit.Passes]: 'Passes',
  [TreatmentUnit.Syringe]: 'Syringe',
};

export class Drug {
  public id: number | any;
  public clinic: any | any;
  public is_active: boolean | any;
  public is_deleted: boolean | any;
  public is_stock: boolean | any;
  public logo: string | any;
  public logo_url: string | any;
  public manufacturer: any | any;
  public name: string | any;
  public description?: string | any;
  public product_type: any | any;
  public unit: any | any;
  public color_marker: string | any;

  // for frontend
  public _selected: boolean | any;
  public _source: string;
  public show_treatment: boolean | any;
  public UOM: string | any;
  public Description: string | any;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.clinic = data.clinic || void 0;
    this.is_active = data.is_active;
    this.is_deleted = data.is_deleted;
    this.is_stock = data.is_stock;
    this.logo = data.logo || void 0;
    this.logo_url = data.logo_url || void 0;
    this.manufacturer = data.manufacturer || void 0;
    this.name = data.name || void 0;
    this.color_marker = data.color_marker || '#000';
    this._selected = data._selected || void 0;
    this.show_treatment = data.is_stock ? !this.is_deleted : void 0;

    this.product_type = data.product_type;
    this.manufacturer = data.manufacturer;
    this.unit = data.unit; // create a string anyway.
    this.UOM = TREATMENT_UNITS_MAP[data.unit] || data.unit;

    // this._forSelector(data);
  }

  // private _forSelector(data) {
  //     if (typeof data.manufacturer === 'string') {
  //         this.manufacturer = { text: data.manufacturer };
  //     } else {
  //         this.manufacturer = data.manufacturer;
  //     }
  //
  //     if (typeof data.product_type === 'string') {
  //         this.product_type = { text: data.product_type };
  //     } else {
  //         this.product_type = data.product_type;
  //     }
  //
  //     if (typeof data.unit === 'string') {
  //         this.unit = { text: data.unit };
  //     } else {
  //         this.unit = data.unit;
  //     }
  // }
}

export class PNDrug {
  public UOM: string;
  public ServiceId: number | string;
  public ServiceColor: string;
  public Description: string;

  // for frontend
  public id?: number | string;
  public name: string;
  public description: string;
  public _selected: boolean;
  public _source: string;
  public show_treatment: boolean;
  public is_deleted: boolean;
  public is_stock: boolean;
  public is_active: boolean;
  public unit: string;

  constructor(data: any = {}) {
    const serviceId = data?.ServiceId ?? data?.serviceId ?? data?.service_id ?? data?.id;
    const description =
      data?.Description ?? data?.description ?? data?.Name ?? data?.name ?? data?.ServiceName ?? '';
    const isActive = data?.IsActive ?? data?.is_active ?? true;

    this.UOM = data?.UOM ?? data?.UnitOfMeasure ?? data?.unit;
    this.Description = description;
    this.ServiceId = serviceId;
    this.ServiceColor = data?.ServiceColor ?? data?.serviceColor;
    this.id = serviceId;
    this.name = description;
    this.description = description;
    this._selected = data._selected || void 0;
    this._source = data?._source ?? 'pn';
    this.is_active = isActive !== false;
    this.is_deleted = data?.IsDeleted ?? data?.is_deleted ?? !this.is_active;
    this.is_stock = data?.is_stock ?? false;
    this.unit = this.UOM;
    this.show_treatment = this.is_active;
  }
}
